module.exports = __webpack_public_path__ + "static/media/md-airplane.9f993609.svg";